import { render } from "./NewStandardComponent.vue?vue&type=template&id=0fcc978e&scoped=true"
import script from "./NewStandardComponent.vue?vue&type=script&lang=js"
export * from "./NewStandardComponent.vue?vue&type=script&lang=js"

import "./NewStandardComponent.vue?vue&type=style&index=0&id=0fcc978e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcc978e"]])

export default __exports__